import React from "react"
import PropTypes from "prop-types"
import AllButton from "./AllButton"
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/solid"

const FilterBlock = ({
  name,
  checkedState,
  setCheckedState,
  setCurrentPage,
  setId,
  length,
  items,
  isOpen,
  setIsOpen,
}) => {
  return (
    <>
      <p className="mt-5 mb-2.5 text-lg leading-loose tracking-wide text-neutral-600 sm:text-xl sm:whitespace-nowrap sm:mr-16 sm:my-0">
        {name}
      </p>
      {/* TopicFilter */}
      <div>
        <div className={`sm:h-full ${isOpen ? "" : "h-28 overflow-hidden"}`}>
          <AllButton
            checkedState={checkedState}
            setCheckedState={setCheckedState}
            setCurrentPage={setCurrentPage}
            setId={setId}
            length={length}
          />
          {items}
        </div>
        <button
          className="flex items-center py-2.5 sm:hidden"
          onClick={() => {
            setIsOpen(prev => !prev)
          }}
        >
          <p className="text-amber-400 sm:text-lg">了解更多</p>
          {isOpen ? (
            <ChevronUpIcon className="h-6 text-amber-400 sm:h-8" />
          ) : (
            <ChevronDownIcon className="h-6 text-amber-400 sm:h-8" />
          )}
        </button>
      </div>
    </>
  )
}

FilterBlock.propTypes = {
  name: PropTypes.string,
  checkedState: PropTypes.array,
  setCheckedState: PropTypes.func,
  setCurrentPage: PropTypes.func,
  setId: PropTypes.func,
  length: PropTypes.number,
  items: PropTypes.array,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
}

export default FilterBlock
